import { createSlice } from '@reduxjs/toolkit';
import api from '../services/api';
import { updateUserSubscriptionReducer, removeUserSubscriptionReducer } from './reducers';
import { SubscriptionSliceState } from './types';
import { SubscriptionState } from '../../types';

const initialState: SubscriptionSliceState = {
  current: undefined,
};

const subscriptionSlice = createSlice({
  name: 'subscription',
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(api.endpoints.googleLogin.matchFulfilled, updateUserSubscriptionReducer);
    builder.addMatcher(api.endpoints.validateToken.matchFulfilled, updateUserSubscriptionReducer);
    builder.addMatcher(api.endpoints.register.matchFulfilled, updateUserSubscriptionReducer);
    builder.addMatcher(api.endpoints.updateUser.matchFulfilled, updateUserSubscriptionReducer);
    builder.addMatcher(api.endpoints.deleteAccount.matchFulfilled, removeUserSubscriptionReducer);
  },
});

const hasSubscription = (state: SubscriptionSliceState) => !!state.current;

const isWaitingForPayment = (state: SubscriptionSliceState) => hasSubscription(state) && state.current?.state === SubscriptionState.WAITING_FOR_PAYMENT;
const isActive = (state: SubscriptionSliceState) => hasSubscription(state) && state.current?.state === SubscriptionState.ACTIVE;
const isExpired = (state: SubscriptionSliceState) => hasSubscription(state) && state.current?.state === SubscriptionState.EXPIRED;
const isCancelled = (state: SubscriptionSliceState) => hasSubscription(state) && state.current?.state === SubscriptionState.CANCELLED;
const showNotification = (state: SubscriptionSliceState) => hasSubscription(state) && state.current?.showNotification;

export default subscriptionSlice;

export const actions = subscriptionSlice.actions;
export const selectors = {
  hasSubscription,
  isWaitingForPayment,
  isActive,
  isExpired,
  isCancelled,
  showNotification,
};
